export class Inputs {
    constructor(clientName = "", state = "", purchaseAge = "", gender = "", calculatedBy = "", investmentAmount = "") {
        this.clientName = clientName;
        this.state = state;
        this.purchaseAge = purchaseAge;
        this.gender = gender;
        this.calculatedBy = calculatedBy;
        this.investmentAmount = investmentAmount;
    }
}
